var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 35,
    width: 35,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.597 5.837c-7.306.856-12.976 7.036-12.976 14.53C2.621 28.447 9.211 35 17.337 35c8.127 0 14.716-6.553 14.716-14.633 0-7.495-5.67-13.674-12.976-14.53V4.292h2.679c2.03 0 2.03-4.292 0-4.292h-8.838c-2.03 0-2.03 4.292 0 4.292h2.679zm3.75 7.384l1.793-1.644.36 2.4-2.37 6.683c.172.366.207.797.06 1.21a1.605 1.605 0 01-2.045.972 1.592 1.592 0 01-.169-2.937l2.371-6.683zM17.337 8.1C10.526 8.1 5 13.593 5 20.367s5.525 12.267 12.338 12.267c6.812 0 12.337-5.493 12.337-12.267S24.15 8.1 17.338 8.1z",
    fill: "#444",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/consumer/account/upcoming-menus/promo-banners/less-prep/time-f24b2f80195cd8fe8e81ac4fe8cef7be.svg";
export { SvgTime as Component };